import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { FieldArray } from 'react-final-form-arrays';
import { Grid } from '@mui/material';

import { Button, Typography, TextField, ChipBox, ChipType } from '@occc-app/design-system';

import { parseAttributeInput } from '../LocationUpdatePage/utils';

const LocationAttributesFormContent: React.FC = () => {
  const [attribute, setAttribute] = useState<string>('');

  return (
    <div>
      <Typography variant='body2' color='textSecondary' paragraph>
        Enter a single attribute or a comma separated list
      </Typography>

      <FieldArray name='attributes'>
        {({ fields }) => {
          const handleAddAttribute = (newAttribute: string) => {
            const attributeList = newAttribute.split(',');
            attributeList.forEach((attribute) => {
              const trimmedAttribute = attribute.trim();

              if (isEmpty(trimmedAttribute)) return;

              fields.push(trimmedAttribute);
            });

            setAttribute('');
          };

          const handleRemoveAttribute = (index: number) => {
            fields.remove(index);
          };

          const handleSubmitAttributes = (attributes: string) => {
            setAttribute(attributes);
          };
          const items =
            fields?.value?.map<ChipType>((name, index) => ({
              name,
              id: index.toString(),
            })) || [];
          const handleOnDelete = (index: string) => {
            handleRemoveAttribute(Number(index));
          };
          return (
            <div>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField
                    onChange={({ target }) => handleSubmitAttributes(target.value)}
                    label='Name'
                    name='name'
                    value={attribute}
                    required={false}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Button
                    variant='contained'
                    color='primary'
                    disabled={!parseAttributeInput(attribute).length}
                    onClick={() => handleAddAttribute(attribute)}
                    sx={{
                      height: '100%',
                      width: '100%',
                    }}
                  >
                    Add Attribute
                  </Button>
                </Grid>
              </Grid>

              <ChipBox items={items} onDelete={handleOnDelete} />
            </div>
          );
        }}
      </FieldArray>
    </div>
  );
};

export default LocationAttributesFormContent;
